import type { PopularRecipe, RecipeFavourite } from "@/types/recipe";

export type RecipeStatus = "Published" | "Draft" | "Archived";

export interface DisplayRecipe {
  id: number;
  name: string;
  status: RecipeStatus;
  station?: string;
  prepTime?: string;
  target?: string;
  imageUrl?: string | null;
}

export function fromFavourite(favourite: RecipeFavourite): DisplayRecipe {
  return {
    id: favourite.recipe.id,
    name: favourite.recipe.name,
    status: favourite.recipe.isPublished ? "Published" : "Draft",
    prepTime: favourite.recipe.prepTimeMinutes ? `${favourite.recipe.prepTimeMinutes}m` : undefined,
    imageUrl: favourite.recipe.imageUrl,
  };
}

export function fromPopular(recipe: PopularRecipe): DisplayRecipe {
  return {
    id: recipe.id,
    name: recipe.name,
    status: recipe.isPublished ? "Published" : "Draft",
    prepTime: recipe.prepTimeMinutes ? `${recipe.prepTimeMinutes}m` : undefined,
    imageUrl: recipe.imageUrl,
  };
}
